import React, { Component ,useEffect, useState} from 'react';

import InputText from '../../../../commonModules/interface/form-input-inline';
import { isEmpty } from 'lodash'
import PopUp from '../../../../commonModules/interface/PopUp';
import { toast } from 'react-toastify';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

const FormClientNew = (props) => {
    const [state,setState] = useState({ 
        client : props.client || {},
        errors: {
            client_lastname: "",
            client_firstname: "",
            client_tel: "",
            client_address: "",
            client_city: "",
            client_country: "",
        }
    })

    const handleChange = (e) => {
        const { name, value} = e.target;
        setState(prevState => ({...prevState,
            client:{
                ...state.client,
                [name]: value
            }
        }))
    }
    const validate = () => {
        let required = [
            "client_lastname",
            "client_firstname",
            "client_tel",
            "client_address",
            "client_city",
            "client_country",
            "client_type",
        ]
        if (state.client["client_type"]=== "professionnel"){
            required.push("client_companyname");
            required.push("client_ifu");
            required.push("client_rccm");
            required.push("client_email")
        }
        let errors = Object.assign({}, state.errors)
        let noErrors = true

        required.forEach( field => {
            if (isEmpty(state.client[field])) {
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }
        })

        setState(prevState => ({...prevState,errors}))
        return noErrors
    }
    const handleSubmit = async () => {
        if(validate()){
            try{
                const resp = await props.createClient(state.client)
                toast.info( "Le client a été modifié avec succès")
                props.handleClose()
            }catch(err){
                toast.error("ERROR"+err.message)
            }
                           
        } else {
            toast.error(  "Le formulaire contient des erreurs") 
        }
    }


        return (
            <PopUp
                close={props.handleClose}
                submitAction={handleSubmit}
                disabledSubmit={props.STATE.clients.fetching}
                title="Créer un nouveau client"
            >                
                               
                <FormLabel component="legend">Type de client</FormLabel>
                <RadioGroup aria-label="client_type" name="client_type" value={state.client.client_type} onChange={handleChange}>
                  <FormControlLabel value="particulier" control={<Radio />} label="Particulier" />
                  <FormControlLabel value="professionnel" control={<Radio />} label="Professionnel" />
                </RadioGroup>
               {(state.client.client_type ==="professionnel") &&
                <>
                        <InputText 
                        change={handleChange} 
                        value={state.client.client_companyname} 
                        name="client_companyname" 
                        title="Nom entreprise *" 
                        error={state.errors.client_companyname}  />
                        <InputText 
                        change={handleChange} 
                        value={state.client.client_ifu} 
                        name="client_ifu" 
                        title="Numero IFU *" 
                        error={state.errors.client_ifu} />
                        <InputText 
                        change={handleChange} 
                        value={state.client.client_rccm} 
                        name="client_rccm" 
                        title="Numero RCCM *" 
                        error={state.errors.client_rccm} />
                        <InputText 
                        change={handleChange} 
                        value={state.client.client_website} 
                        name="client_website" 
                        title="Site Web Client" 
                        error={state.errors.client_website} />
                    </>
                }
                <InputText  
                    change={handleChange} 
                    value={state.client.client_lastname} 
                    name="client_lastname" 
                    title="Nom"
                    error={state.errors.client_lastname}  
                    required 
                />
                <InputText  
                    change={handleChange} 
                    value={state.client.client_firstname} 
                    name="client_firstname" 
                    title="Prénom"
                    error={state.errors.client_firstname}  
                    required 
                /> 
                <InputText 
                    change={handleChange} 
                    value={state.client.client_tel} 
                    name="client_tel" 
                    title="Téléphone"
                    error={state.errors.client_tel}  
                    required 
                />
    
                <InputText  
                    change={handleChange} 
                    value={state.client.client_email} 
                    name="client_email" 
                    title="Email"  
                    error={state.errors.client_email}  
                />
                
                <InputText  
                    change={handleChange} 
                    value={state.client.client_address} 
                    name="client_address" 
                    title="Adresse" 
                    error={state.errors.client_address}  
                    required 
                />
                
                <InputText  
                    change={handleChange} 
                    value={state.client.client_city} 
                    name="client_city" 
                    title="Ville"
                    error={state.errors.client_city}  
                    required 
                />
                
                <InputText  
                    change={handleChange} 
                    value={state.client.client_country} 
                    name="client_country" 
                    title="Pays"
                    error={state.errors.client_country}  
                    required
                />
               
            </PopUp>
        );

}

export default FormClientNew;